// Framework and third-party non-ui
import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core";
import { useMediaQuery } from 'react-responsive';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import AppleAppStoreImage from 'assets/icons/AppleStore.svg';
import GoogleAppStoreImage from 'assets/icons/GooglePlay.svg';
import AppStores from 'configs/AppStores';
import { AppStorePageLayout, SplashPageLayout, StyledTermsContainer, TopLeftImage, TopMiddleImage, BottomBanner, ImageAndTermsFlex } from './SplashPage-styled';

const APPLE_URL = AppStores.APPLE_STORE;
const GOOGLE_URL = AppStores.GOOGLE_PLAY;

// JSON & Styles

  // Third-party components (buttons, icons, etc.)
  const SplashPage = () => {
    const history = useHistory();
  
    function handleClick() {
      localStorage.setItem("userConditionAgreed",true)
      history.push("/home");
    }
    const isTabletOrMobileDevice = useMediaQuery({ query: ( '(max-device-width: 1224px)' ) });
    const useStyles = makeStyles((theme) => ({
      root: {
        maxWidth: 345,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: '5px 5px',
      },
      h3: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '25px',
        lineHeight: '24px',
        /* identical to box height */
        
        textAlign: 'center',
        letterSpacing: '0.15px',
        
        /* SecondaryDarkGray */
        
        color: '#222222',
        flex: 'none',
        order: '0',
        alignSelf: 'center',
        flexGrow: '0'
      },
      body2: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        /* or 143% */
        
        letterSpacing: '0.25px',
        
        /* 00. On Surface / Medium Emphasis */
        
        color: 'rgba(0, 0, 0, 0.6)',
        /* Inside Auto Layout */

        flex: 'none',
        order: '1',
        alignSelf: 'flex-start',
        flexGrow: '0',
        margin: '5% 0px 5%'
      },
      aacButton: {
        position: 'static',
        width: '168px',
        height: '25px',
        left: '15px',
        top: '7.5px',
        
        /* Label/Button */
        
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '175%',
        /* identical to box height, or 24px */
        
        display: 'flex',
        alignItems: 'center',
        letterSpacing: '0.75px',
        textTransform: 'uppercase',
        
        /* PrimaryWhite */
        
        color: '#FFFFFF',
        
        /* Inside Auto Layout */
        
        flex: 'none',
        order: '0',
        alignSelf: 'center',
        flexGrow: '0',
        // margin: '10px 0px'
      },
      takeYourDetour: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '22px',
        /* identical to box height */
        
        textAlign: 'center',
        letterSpacing: '0.25px',
        
        /* PrimaryWhite */
        
        color: '#FFFFFF',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
      },
      appStore: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '20px',
        lineHeight: '24px',
        /* identical to box height */
        
        textAlign: 'center',
        letterSpacing: '0.15px',
        
        /* PrimaryWhite */
        
        color: '#FFFFFF',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
      },
      media: {
        height: '40px',
        width: '135px',
        justifyContent: 'space-between',
      },
      download: {
        margin: '40px 0px 0px 0px',
      },
    })
    )


    /**
     * title component
     * @param { title} props 
     */
    const TitleComp = (props) => {
      const classes = useStyles()
      return (
        <Typography
        className={classes.h3}
        >
          Terms of Service
        </Typography>
      )
    }

    /**
     * Terms of Service component
     * @param {*} props 
     */
    const TOSComp = (props) => {
      const classes = useStyles()
      return (
        <Typography className={classes.body2}>
        By downloading, accessing or using DETOUR or any page of this website or mobile app, you signify your assent to this disclaimer. The contents of this website and mobile app, including without limitation, all data, information, text, graphics, links and other materials are provided as a convenience to our website and mobile app users and are meant to be used for informational purposes only. We do not take responsibility for decisions taken by the user based solely on the information provided in this website or mobile app. 
  Use of the website or mobile app is at your own risk. The apps are provided on an “as is” basis. ODNR accepts no responsibility for any technical failure of the internet, GPS signal, cellular/LTE signal or any damage or injury to users or their property as a result of or relating to their use of the website or mobile app.
  All actions taken by the user of this website or mobile app are conducted solely at their own risk. The user shall employ all proper safeguards to prevent any and all injuries or damage to any person or property, employees or property of the department, material or thing. 
  The user of this website or mobile app agrees that it shall keep itself fully informed of all laws, ordinances, rules and regulations in any manner affecting use of this website or mobile app and facilities and all orders and decrees of bodies and tribunals having jurisdiction or authority over the same. The user shall at all times observe and comply with such existing laws, ordinances, regulations, orders and decrees.  The user shall pay any fee or purchase any license required to use or enter any trail or property requiring such.  
  ODNR has worked to ensure the accuracy of the information provided through this website and mobile app. The images, data, attributes and descriptions that appear in this website or mobile app reflect the research at the time of publication. Please be advised that this information frequently relies on data obtained from many sources, and accordingly, ODNR cannot guarantee the accuracy of the information provided.  Moreover, in light of changing seasons, weather conditions, erosion, hazards, and other factors, this information may no longer be current.
  Please not that this website and mobile app are linked to other websites that may have different terms of use and privacy policies. Please refer to those websites and mobile applications for the appropriate information. Please understand that ODNR has no control over the content of these third party websites and mobile applications. In addition, a hyperlink to a non-ODNR website or link to access a third party mobile application does not mean that ODNR endorses or accepts any responsibility for the content or the use, of the linked website or mobile application. If you decide to access any of the third party websites or mobile applications linked to this website, you do so entirely at your own risk.
      </Typography>
      )
    }

      /**
     * Agree and continue component
     * @param {*} props 
     */
    const AACComp = (props) => {
      return (
        <Button variant="contained" color="primary" className="AACComp" onClick={handleClick} disableElevation>
          Agree and Continue
        </Button>
      )
    }

    const DownloadApp = () => {
      function handleAppleStoreClick() {
        window.open(APPLE_URL, "_blank")
      }

      function handleGoogleStoreClick() {
        window.open(GOOGLE_URL, "_blank")
      }
      const handleEnter = (keyCode, fn) => {
        if(keyCode === 13){
            fn();
        }
      }
      const classes = useStyles()
      return (
        <>
        <Typography className={classes.download}>DOWNLOAD THE APP</Typography>
        <div className={classes.root}>
            <Card className={classes.root} onKeyUp={(e) => {handleEnter(e.keyCode, handleAppleStoreClick)}} aria-label="Download App From Apple Store Link">
              <CardActionArea>
                <CardMedia
                  className={classes.media}
                  component="img" src={AppleAppStoreImage}
                  title="Open Apple Store"
                  onClick={handleAppleStoreClick}
                />
              </CardActionArea>
            </Card>
            <Card className={classes.root} onKeyUp={(e) => {handleEnter(e.keyCode, handleGoogleStoreClick)}} aria-label="Download App From Google Play Store Link">
              <CardActionArea>
                <CardMedia
                  className={classes.media}
                  component="img" src={GoogleAppStoreImage}
                  title="Open Google Store"
                  onClick={handleGoogleStoreClick}
                />
              </CardActionArea>
            </Card>
          </div>
        </>
      )
    };

    const SplashContent = (props) => {
      const classes = useStyles()

      return (
        isTabletOrMobileDevice ? 
        (<main>
          <AppStorePageLayout>
            <TopLeftImage />
            <Typography className={classes.appStore}>Please download the app for your device.</Typography>
            <DownloadApp />
            <BottomBanner>
              <Typography className={classes.takeYourDetour}>Take Your DE<strong>TOUR</strong></Typography>
            </BottomBanner>
          </AppStorePageLayout>
        </main>)
        :
        (<main>
          <SplashPageLayout>
            <TopLeftImage />
            <ImageAndTermsFlex>
              <TopMiddleImage />
              <StyledTermsContainer tabIndex="0">
                <section className="centerInBrowser">
                  <TitleComp />
                  <TOSComp />     
                </section>
              </StyledTermsContainer>
              <AACComp />
            </ImageAndTermsFlex>
            <BottomBanner>
              <Typography className={classes.takeYourDetour}>Take Your DE<strong>TOUR</strong></Typography>
            </BottomBanner>
          </SplashPageLayout>
        </main>)
      )
    };
    return (

      <SplashContent />

    );
};

export default SplashPage;
